import { render, staticRenderFns } from "./StandingsForm.vue?vue&type=template&id=793818a5&scoped=true"
import script from "./StandingsForm.vue?vue&type=script&lang=js"
export * from "./StandingsForm.vue?vue&type=script&lang=js"
import style0 from "./StandingsForm.vue?vue&type=style&index=0&id=793818a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793818a5",
  null
  
)

export default component.exports